module.exports = "<p>\n  superadmin works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/superadmin/superadmin.component.html
// module id = ./src/app/modules/superadmin/superadmin.component.html
// module chunks = main